import PageContent from '../components/PageContent';

function HomePage() {
  return (
    <PageContent
      title="Experience Unforgettable Events with Our Professional Event Planning Services"
      button
    >
      <p>
        Welcome to Event Planner, where we transform your vision into reality.
        Get ready to celebrate in style and leave a lasting impression on your
        guests.
      </p>
    </PageContent>
  );
}

export default HomePage;
